export const iconFontAwesomeEducationAppleWhole = (
	<i className="fa-solid fa-apple-whole"></i>
);
